export function parseRound(raw: string): number {
    return Math.round(parseFloat(raw))
}